import { render } from "./QuotePage.vue?vue&type=template&id=c211d814"
import script from "./QuotePage.vue?vue&type=script&lang=js"
export * from "./QuotePage.vue?vue&type=script&lang=js"

import "@/css/QuotePage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__